














































































import {
  Component,
  Vue,
  Prop,
  Ref,
  Watch,
  PropSync,
  Inject,
} from "vue-property-decorator";
import { FormItem } from "@/components/DinamicallyForm/FormItem";
import { UtilsString } from "@/utils/utils-string";
import i18n from "@/i18n/i18n";

@Component({
  components: {},
})
export default class TableSelectCodigoDescripcion extends Vue {
  @PropSync("item") formItem!: FormItem;
  @Inject("$validator") $validator!: any;

  public codigo = "";
  public descripcion = "";
  public menu = false;
  public searchText = "";

  public created() {
    try {
      let ids = this.formItem.Codigo_Descripcion_selector.AllDataSource.filter(
        (x: any) =>
          x[this.formItem.Codigo_Descripcion_selector.ValueNameColumn] ===
          this.formItem.data
      );
      if (ids !== undefined && ids.length > 0) {
        this.codigo =
          ids[0][this.formItem.Codigo_Descripcion_selector.CodigoNameColumn];
        this.formItem.data =
          ids[0][this.formItem.Codigo_Descripcion_selector.ValueNameColumn];
        return ids[0][
          this.formItem.Codigo_Descripcion_selector.DescripcionNameColumn
        ];
      } else {
        this.codigo = "";
        this.formItem.data = undefined;
        return "";
      }
    } catch (error) {}
  }

  public upper() {
    this.codigo = this.codigo.toUpperCase();
  }

  public changeCodigo(e: any) {
    e = UtilsString.ValueOf(e).toUpperCase();
    this.searchWithCode();
  }

  @Watch("codigo")
  public searchWithCode() {
    this.codigo = this.codigo.toUpperCase();

    this.codigo = UtilsString.ValueOf(this.codigo).toUpperCase();
    let codigos = this.formItem.Codigo_Descripcion_selector.AllDataSource.filter(
      (x: any) =>
        x[
          this.formItem.Codigo_Descripcion_selector.CodigoNameColumn
        ].toUpperCase() === this.codigo.toUpperCase()
    );
    if (codigos !== undefined && codigos.length > 0) {
      this.codigo =
        codigos[0][this.formItem.Codigo_Descripcion_selector.CodigoNameColumn];
      this.formItem.data =
        codigos[0][this.formItem.Codigo_Descripcion_selector.ValueNameColumn];
      this.descripcion =
        codigos[0][
          this.formItem.Codigo_Descripcion_selector.DescripcionNameColumn
        ];
    } else {
      this.codigo = "";
      this.formItem.data = undefined;
      this.descripcion = "";
    }
    if (this.formItem.data !== undefined) {
      this.$emit("change", this.formItem.data);
    }
    //para cuando se quiera hacer siempre y nos saltamos la comprobación anterior. te susbcribes a 1 o otro.
    this.$emit("changeAll", this.formItem.data);
  }

  @Watch("formItem.data")
  public searchInputValue() {
    let codigos = this.formItem.Codigo_Descripcion_selector.AllDataSource.filter(
      (x: any) =>
        x[this.formItem.Codigo_Descripcion_selector.ValueNameColumn] ===
        this.formItem.data
    );
    if (codigos !== undefined && codigos.length > 0) {
      this.codigo =
        codigos[0][this.formItem.Codigo_Descripcion_selector.CodigoNameColumn];
      this.formItem.data =
        codigos[0][this.formItem.Codigo_Descripcion_selector.ValueNameColumn];
      this.descripcion =
        codigos[0][
          this.formItem.Codigo_Descripcion_selector.DescripcionNameColumn
        ];
    } else {
      this.codigo = "";
      this.formItem.data = 0;
      this.descripcion = "";
    }
  }

  public rowClick(e: any) {
    this.codigo = e[this.formItem.Codigo_Descripcion_selector.CodigoNameColumn];
    this.formItem.data =
      e[this.formItem.Codigo_Descripcion_selector.ValueNameColumn];
    //this.descripcion = e.descripcion;
    this.menu = false;
  }

  public get headers() {
    let cols = [
      {
        text: UtilsString.ValueOf(
          i18n.t(
            UtilsString.ValueOf(
              this.formItem.Codigo_Descripcion_selector.CodigoNameColumn
            ).toLowerCase()
          )
        ),
        value: this.formItem.Codigo_Descripcion_selector.CodigoNameColumn,
      },
      {
        text: UtilsString.ValueOf(
          i18n.t(
            UtilsString.ValueOf(
              this.formItem.Codigo_Descripcion_selector.DescripcionNameColumn
            ).toLowerCase()
          )
        ),
        value: this.formItem.Codigo_Descripcion_selector.DescripcionNameColumn,
      },
    ];
    for (
      let i = 0;
      i < this.formItem.Codigo_Descripcion_selector.MoreColumns.length;
      i++
    ) {
      cols.push({
        text: UtilsString.ValueOf(
          i18n.t(
            UtilsString.ValueOf(
              this.formItem.Codigo_Descripcion_selector.MoreColumns[i]
            ).toLowerCase()
          )
        ),
        value: this.formItem.Codigo_Descripcion_selector.MoreColumns[i],
      });
    }
    return cols;
  }

  private GetValidation(field: FormItem) {
    let validacion = "";

    if (field.Required) {
      validacion = "required";
    }
    field.validacion = field.validacion.replace("numeric", "");
    field.validacion = field.validacion.replace("||", "|");
    if (field.validacion.toString().trim().length !== 0) {
      if (validacion !== "") {
        validacion += "|";
      }
      validacion += field.validacion;
    }
    return validacion;
  }
}
